import React, { useEffect } from 'react';
import { Form, FormInstance, Input, Select } from 'antd';
import { EventOwner } from '../index.page';

interface EventOwnerFormProps {
  form: FormInstance;
  initialValues?: EventOwner;
}

const EventOwnerForm: React.FC<EventOwnerFormProps> = ({ form, initialValues }) => {
  // Set form values when initialValues change (for editing)
  useEffect(() => {
    if (initialValues) {
      // Set form values
      const formValues = {
        ...initialValues
      };
      form.setFieldsValue(formValues);
    }
  }, [initialValues, form]);
  return (
    <Form
      form={form}
      layout="vertical"
      requiredMark={false}
      className="compact-form"
    >
      <Form.Item
        name="name"
        label="Name"
        rules={[{ required: true, message: 'Please enter name' }]}
      >
        <Input placeholder="Enter name" />
      </Form.Item>

      <Form.Item
        name="email"
        label="Email"
        rules={[
          { required: true, message: 'Please enter email' },
          { type: 'email', message: 'Please enter a valid email' }
        ]}
      >
        <Input placeholder="Enter email" />
      </Form.Item>

      <Form.Item
        name="mobile"
        label="Mobile Number"
        rules={[{ required: true, message: 'Please enter mobile number' }]}
      >
        <Input placeholder="Enter mobile number" />
      </Form.Item>

      <div className="mb-4">
        <h4 className="mb-1 text-sm font-medium">Event Owner Status</h4>
        <p className="text-xs text-gray-500">
          Choose whether the event owner is active or inactive. Event owner can be made inactive, which means they no longer have access, but they are still linked to events
        </p>
      </div>

      <Form.Item
        name="status"
        label="Status"
        rules={[{ required: true, message: 'Please select status' }]}
      >
        <Select placeholder="Select">
          <Select.Option value="active">Active</Select.Option>
          <Select.Option value="inactive">Inactive</Select.Option>
        </Select>
      </Form.Item>
    </Form>
  );
};

export default EventOwnerForm;
